import { useEffect } from 'react';

const SocialBarAd = () => {
    useEffect(() => {
        // ၁။ Script tag အသစ်တစ်ခု ဖန်တီးခြင်း
        const script = document.createElement('script');
        {/* <script src="https://pl31658006.profitableratecpmnetwork.com/70/29/2e/70292eb1bac2cf93e394f5b2b1d7d59d.js"></script> */ }
        // Adsterra ကပေးထားသော Social Bar Link
        script.src = "https://pl31658006.profitableratecpmnetwork.com/70/29/2e/70292eb1bac2cf93e394f5b2b1d7d59d.js";
        script.type = 'text/javascript';
        script.async = true;

        // ၂။ Body ထဲသို့ ထည့်သွင်းခြင်း
        document.body.appendChild(script);

        return () => {
            // ၃။ Component ပိတ်သွားရင် cleanup လုပ်ရန်
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return null; // မျက်နှာပြင်မှာ ဘာမှပြစရာမလိုလို့ null ပြန်ထားပါတယ်
};

export default SocialBarAd;